import React from 'react';

import BasePage from 'apps/auth/components/utils/BasePage';
import Spinner from 'apps/auth/components/utils/Spinner/Spinner';

const DeepLink = () => {
    return <Spinner forceShow={true} isEmptyText />;
};

export default BasePage(DeepLink);
